import React from 'react';

// Helpers
import { checkValidity } from '../../helpers/helpers.js'

// Dependencies
import moment from 'moment';

class TimeZone extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReset = this.handleReset.bind(this);

    // Set the initial state
    this.state = {
      convertedTimes: []
    }
  }

  handleSubmit() {
    const convertedTimes = [];
    const timestamp = this.timestamp.value;
    const timeZones = ['America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles', 'US/Alaska', 'US/Hawaii'];

    timeZones.forEach(timeZone => {
      let convertedTime = null;

      if(moment(timestamp).isValid()) {
        convertedTime = `${moment(timestamp).tz(timeZone).format('MM/DD/YYYY [at] h:mma z')}`;
      } else {
        // Try converting from epoch if the
        // provided date wasn’t valid
        convertedTime = `${moment.unix(timestamp).tz(timeZone).format('MM/DD/YYYY [at] h:mma z')}`;
      }

      convertedTimes.push(convertedTime);
    });

    this.setState({
      convertedTimes
    });
  }

  handleReset() {
    this.timestamp.value = '';

    this.setState({
      convertedTimes: []
    });
  }

  render() {
    return(
      <main tabIndex="0" id="main-content" className="page wrap">
        <div className="panel--brief">
          <h1 className="panel__title">Time Zone Extractor</h1>

          <form className="form-inline" onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
            <ul className="fields">
              <li>
                <label
                  className="lbl-required"
                  htmlFor="timestamp"
                >
                  Timestamp
                </label>

                <input
                  type="text"
                  id="timestamp"
                  ref={(input) => this.timestamp = input}
                  required
                  aria-required="true"
                  autoFocus
                />
              </li>
            </ul>

            <button
              className="btn btn--inline"
              type="submit"
            >
              Submit
            </button>
          </form>

          {this.state.convertedTimes.length > 0 &&
            <div>
              <table className="compact">
                <tbody>
                  {this.state.convertedTimes.map(
                    (time, i) =>
                    <tr key={i}>
                      <td>{time}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          }
        </div>
      </main>
    )
  }
}

export default TimeZone;



// WEBPACK FOOTER //
// ./src/app/components/Outside/TimeZone.js